import { Icon } from "Components";
import React from "react";
import "./header.scss";

type HeaderProps = {
    title: string,
    description: string,
    parentClass?: string,
    children?: React.ReactNode,
    onBack?: () => void
}

const Header: React.FC<HeaderProps> = ({
    title,
    description,
    parentClass = null,
    onBack = null,
    children = null }) => {
    return <div className={`section-header ${parentClass || ''}`}>
        <div className="pm-header-content">
            <div className="pm-title-group">
                <div className="pm-title-wrapper">
                    {onBack && <div className="pm-back-icon" onClick={onBack}>
                        <Icon type="summaryBack" />
                    </div>}
                    <h3 className="pm-title">{title}</h3>
                </div>
                <p className="pm-subtitle">{description}</p>
            </div>
            {children && <div className="pm-actions">
                {children}
            </div>}
        </div>
    </div>
}

export default Header;